export default "__VITE_ASSET__BCiSxjBV__"